// BankTransferNote.jsx — aviso de que la transferencia se hace en el banco del donante, compartido por Persona y Empresa.

import React from 'react'

function BankTransferNote() {
  return (
    <div className="card" style={{ padding: 24, fontSize: 12, color: "var(--fg-dim)", lineHeight: 1.55 }}>
      ⚠️ Importante: La transferencia se realiza en tu banco. Este formulario es solo para documentar tu aporte. Haz la transferencia en tu banco a nuestra cuenta:
    </div>
  );
}

export { BankTransferNote };
